export default __webpack_public_path__ + "static/media/vscode.274b1c25.webp";